import React from "react";
import PortalLayout from "../components/PortalLayout";

export default function Privacy() {
    return (
        <PortalLayout>
            <section className="max-w-2xl mx-auto px-6 md:px-12 pt-20 pb-32" data-testid="privacy-page">
                <span className="font-label text-[11px] text-[#cfa052]">Legal</span>
                <h1 className="mt-4 font-serif-display text-5xl md:text-6xl tracking-tighter text-[#e8e4db]">Privacy Policy</h1>
                <p className="mt-3 font-poetic text-sm text-[#6e6a62]">Last updated: February 2026</p>

                <div className="mt-12 space-y-8 font-poetic text-[#9a958a] text-lg leading-relaxed">
                    <p>
                        Angel Squad is a private member portal. We collect only the information you give us — your email, the name you wish to be greeted by, and the Angel you choose. We do not sell your data.
                    </p>

                    <div>
                        <h2 className="font-serif-display text-2xl text-[#e8e4db] mb-3">What we store</h2>
                        <ul className="space-y-2 list-none">
                            <li>— Email address (used for sign-in only).</li>
                            <li>— Display name and the date you joined.</li>
                            <li>— The Angel number you selected.</li>
                            <li>— Any messages you submit through the Contact page.</li>
                        </ul>
                    </div>

                    <div>
                        <h2 className="font-serif-display text-2xl text-[#e8e4db] mb-3">Cookies</h2>
                        <p>
                            A single secure, http-only cookie holds your session. It expires after seven days of stillness.
                        </p>
                    </div>

                    <div>
                        <h2 className="font-serif-display text-2xl text-[#e8e4db] mb-3">Your rights</h2>
                        <p>
                            Write to us via the Contact page to view, correct, or delete anything we hold about you.
                        </p>
                    </div>
                </div>
            </section>
        </PortalLayout>
    );
}
